import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";
import PermissionRoute from "./utils/ProtectedRoute";
import { Login, AcceptInvite, ForgotPassword, ResetPassword, DashboardIndex, Client, ClientInfoEdit, LoansIndex, DetailIndex, ActiveLoans, ActiveLoan, CompletedLoans, RejectedLoans, ApprovedLoan, FacilityLetter, Portfolio, ReversalIndex, PaymentIndex, AdminIndex, StaffIndex, StaffCreate, StaffEdit, ClientIndex, ClientCreate, ClientEdit, NotFound, PreloanIndex, Questions, BusinessIndex, MomoAnalyzer, PaymentsIndex, NpontuPaymentsIndex, NpontuDetails } from "./components";
import RolesIndex from "./components/Admin/Roles/Index";
import PermissionsIndex from "./components/Admin/Permissions/Index";
import TransactionsIndex from "./components/Admin/Transactions/Index";
import ServicesIndex from "./components/Admin/Services/Index";
import PartnerAPIsIndex from "./components/Admin/PartnerAPIs/Index";
import SendSMSIndex from "./components/Admin/SendSMS/Index";
import LoanEditIndex from "./components/Admin/LoanEdit/Index";
import AuditLogIndex from "./components/Admin/AuditLog/Index";
import SettingsIndex from "./components/Settings/Index";
import { fetchConfig } from "./slices/configSlice";

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchConfig());
        const refresh = setInterval(() => dispatch(fetchConfig()), 60 * 60 * 1000);  // 1 hour
        return () => clearInterval(refresh);
    }, [dispatch]);

    return (
        <>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route element={<PermissionRoute />}>
                <Route path="/settings" element={<SettingsIndex />} />
                <Route path="/" exact element={<DashboardIndex />} />
                <Route path="/client/:id" exact element={<Client />} />
                <Route path="/client/edit/:id" exact element={<ClientInfoEdit />} />
                <Route path="/loans" element={<LoansIndex />} />
                <Route path="/:type/:loanId" element={<DetailIndex />} />

                {/* approved loans */}
                <Route path="/approved/:type/:loanId" element={<ApprovedLoan />} />
                {/* end of approved loans */}

                {/* sign facility-letters, collective active and completed loans */}
                <Route path="/facility-letters" element={<FacilityLetter />} />
                <Route path="/active-loans" element={<ActiveLoans />} />
                <Route path="/completed-loans" element={<CompletedLoans />} />
                {/* end of sign facility-letters, collective active and completed loans */}

                {/* active and completed loans */}
                <Route path="/active/:loanId" element={<ActiveLoan />} />
                <Route path="/completed/:loanId" element={<ActiveLoan />} />
                {/* end of active and completed loans */}

                {/* rejected loans */}
                <Route path="/rejected-loans" element={<RejectedLoans />} />
                <Route path="/rejected/:loanId" element={<ActiveLoan />} />
                {/* rejected loans */}

                <Route path="/dashboard" element={<Portfolio />} />
                <Route path="/reversals" element={<ReversalIndex />} />
                <Route path="/payments" element={<PaymentIndex />} />

                <Route path="/preloan" element={<PreloanIndex />} />
                <Route path="/apply/:loanType" element={<Questions />} />

                {/* Momo-Analyzer */}
                <Route path="/momo-analyzer" element={<MomoAnalyzer />} />
                {/* Momo-Analyzer */}

                {/* Admin urls — requires admin:access permission */}
                <Route element={<PermissionRoute permission="admin:access" />}>
                    <Route path="/admin/home" element={<AdminIndex />} />
                    <Route path="/admin/staff" element={<StaffIndex />} />
                    <Route path="/admin/staff/create" element={<StaffCreate />} />
                    <Route path="/admin/staff/edit" element={<StaffEdit />} />
                    <Route path="/admin/clients" element={<ClientIndex />} />
                    <Route path="/admin/clients/create" element={<ClientCreate />} />
                    <Route path="/admin/clients/edit" element={<ClientEdit />} />
                    <Route path="/admin/businesses" element={<BusinessIndex />} />
                    <Route path="/admin/payments" element={<PaymentsIndex />} />
                    <Route path="/admin/npontu-clients" element={<NpontuPaymentsIndex />} />
                    <Route path="/admin/:type/:id" element={<NpontuDetails />} />
                    <Route path="/admin/roles" element={<RolesIndex />} />
                    <Route path="/admin/permissions" element={<PermissionsIndex />} />
                    <Route path="/admin/transactions" element={<TransactionsIndex />} />
                    <Route path="/admin/loan-edit" element={<LoanEditIndex />} />
                    <Route path="/admin/audit-log" element={<AuditLogIndex />} />
                    <Route path="/admin/services" element={<ServicesIndex />} />
                    <Route path="/admin/partner-apis" element={<PartnerAPIsIndex />} />
                    {/* Send SMS — admin only (sms:send) */}
                    <Route element={<PermissionRoute permission="sms:send" />}>
                        <Route path="/admin/send-sms" element={<SendSMSIndex />} />
                    </Route>
                </Route>
                {/* end of Admin urls */}

            </Route>

            {/* error 404 page */}
            <Route path="*" element={<NotFound />} />
            {/* error 404 page */}
        </Routes>
        </>
    );
}

export default App;
